import React, { Component } from "react";
import Firms from "../../../components/Firms/Firms";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : FirmsForm
Description : Componente que invoca al componente Firms, para la creación y consulta de firmas.
Date Autor Modification
================================================================================
1/10/2021 Santiago Coca Rojas Creación – Se llama al componente Firms
================================================================================ */
class FirmsForm extends Component{
    render(){
        return(
            <Firms/>  
        )   
    }
}

export default FirmsForm;